var n;!function(n){n.Nodes="nodes",n.Links="links"}(n||(n={}));export{n as FilterType};
//# sourceMappingURL=types.js.map
